<template>
  <b-card>
    <validation-observer ref="registerForm" #default="{ invalid }">
      <b-form>
        <b-row>
          <!-- <b-col lg="3">
            <b-form-group id="input-group-4" :label="$t('site.code')" label-for="input-4">
              <validation-provider #default="{ errors }" name="quran_program_type" vid="quran_program_type"
                rules="required">
                <b-form-input v-model="newItem.code" type="number" :placeholder="$t('site.code')" />

                <small class="name-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col lg="6">
            <b-form-group id="input-group-1" :label="$t('quran_programs.date_name')" label-for="input-1">
              <validation-provider #default="{ errors }" name="name" vid="name" rules="required">
                <b-form-input v-model="newItem.name" type="text" :placeholder="$t('quran_programs.date_name')" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- .start_date -->
          </b-col>
          <b-col lg="6">
            <b-form-group id="input-group-1" :label="$t('quran_programs.alward')" label-for="input-1">
              <v-select v-model="newItem.alward" dir='rtl' multiple label="title" :options="parts" />

            </b-form-group>
            <!-- .start_date -->
          </b-col>
        
          <b-col lg="3">
            <b-form-group id="input-group-4" :label="$t('quran_programs.quran_program_type')" label-for="input-4">
              <validation-provider #default="{ errors }" name="quran_program_type" vid="quran_program_type"
                rules="required">
                <b-form-select v-model="newItem.type" :options="type" :state="errors.length > 0 ? false : null"
                  :placeholder="$t('quran_programs.quran_program_type')" />
                <small class="name-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group :label="$t('quran_programs.date')">
              <validation-provider #default="{ errors }" name="date" vid="date" rules="required">
                <b-form-datepicker v-model="newItem.date" class="mb-1" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- .start_date -->
          </b-col>

       
          <b-col lg="3">
            <b-form-group :label="$t('quran_programs.start_at')">
              <validation-provider #default="{ errors }" name="start" vid="start" rules="required">
                <b-form-timepicker :disabled="!newItem.date" v-model="newItem.start" locale="ar-EG" @input="setEnd()" />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- .start_date -->
          </b-col>
          <b-col lg="3">
            <b-form-group id="input-group-1" :label="$t('quran_programs.end_at')">
              <validation-provider #default="{ errors }" name="end" vid="end" rules="required">
                <b-form-input type="text" v-model="newItem.end" locale="ar" readonly />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- .start_date -->
          </b-col>
        </b-row>

        <hr />
        <b-row>
          <b-col lg="6">
            <b-btn variant="primary" block @click="submit()" :disabled="invalid">
              <i class="fa fa-plus" /> {{ $t("site.save") }}
            </b-btn>
          </b-col>
          <b-col lg="6">
            <b-btn variant="success" block @click="goToTable()">
              <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
            </b-btn>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import controller from "@/Controllers/QuranScheduleDateController";
import QuranProgramsController from "@/Controllers/QuranProgramsController";
import vSelect from 'vue-select'

export default {
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect
  },
  data() {
    return {
      type: [
        {
          value: "general_meeting",
          text: this.$i18n.t("quran_programs.general_meeting"),
        },
        {
          value: "memorization",
          text: this.$i18n.t("quran_programs.memorization"),
        },
        { value: "revision", text: this.$i18n.t("quran_programs.revision") },
        {
          value: "recitation",
          text: this.$i18n.t("quran_programs.recitation"),
        },
        { value: "test", text: this.$i18n.t("quran_programs.test") },
        {
          value: "quran_sciences",
          text: this.$i18n.t("quran_programs.quran_sciences"),
        },
        {
          value: "giving_ceremony",
          text: this.$i18n.t("quran_programs.giving_ceremony"),
        },
      ],
      parts: [],
      quranProgram: {},
    };
  },
  async created() {
    this.quranProgram = await new QuranProgramsController().Show(
      this.$route.params.id
    );
    for (let index = 1; index < 31; index++) {
      for (let indexalhizb = 1; indexalhizb < 3; indexalhizb++) {
        for (let indexQuarter = 1; indexQuarter < 5; indexQuarter++) {
          this.parts.push("الجزء " +
            index +
            " - الحزب   " +
            indexalhizb +
            " - الربع   " +
            indexQuarter);
        }

      }

    }
    // this.newDate.title =
    //     "- الجزء" +
    //     this.selectItem.partNumber +
    //     " - الحزب - " +
    //     this.selectItem.alhizb +
    //     "- الربع - " +
    //     this.selectItem.quarter;
    console.log(this.quranProgram);
  },
  methods: {
    setEnd() {

      this.newItem.end = this.moment(this.newItem.date + " " + this.newItem.start)
        .add(this.quranProgram.period, "m").locale("en")
        .format("hh:mm A");
    },
    async submit() {
      this.newItem.quran_program_id = this.$route.params.id;
      let ret = await new controller().From(this.newItem, 'FormData');
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
  },
};
</script>
 
  